import { useGameStore } from '@/state/gameStore';
import { selectCowardStatus, selectUltimateCoward } from '@/state/selectors';
import styles from './CowardWatermark.module.css';

/**
 * Permanent "COWARD" stamp injected into the monitor chrome after a
 * checkpoint save. Ultimate Coward deepens the colour and doubles the
 * stamp into an X — the brand the player earned.
 */
export function CowardWatermark() {
  const coward = useGameStore(selectCowardStatus);
  const ultimate = useGameStore(selectUltimateCoward);
  if (!coward) return null;

  return (
    <div
      className={styles.watermark}
      data-testid="coward-watermark"
      data-ultimate={ultimate ? 'true' : 'false'}
      aria-hidden="true"
    >
      <span className={styles.stamp}>COWARD</span>
      {ultimate && <span className={styles.secondStamp}>COWARD</span>}
    </div>
  );
}
